interface SkeletonProps {
  className?: string
}

/**
 * Base skeleton component with animated pulse effect
 */
export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
  )
}

/**
 * Skeleton for user info section in sidebar
 * Matches the layout of the user avatar, name, and subscription badge
 */
export function UserInfoSkeleton() {
  return (
    <div className="flex items-center gap-3">
      {/* Avatar skeleton */}
      <Skeleton className="w-10 h-10 rounded-full flex-shrink-0" />
      <div className="min-w-0 flex-1">
        {/* Name skeleton */}
        <Skeleton className="h-4 w-24 mb-2" />
        {/* Subscription badge skeleton */}
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
    </div>
  )
}

interface AvatarSkeletonProps {
  size?: 'sm' | 'md' | 'lg'
}

/**
 * Skeleton for avatar in header
 */
export function AvatarSkeleton({ size = 'md' }: AvatarSkeletonProps) {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  }
  return <Skeleton className={`${sizes[size]} rounded-full`} />
}

/**
 * Skeleton for profile dropdown content in header
 */
export function ProfileDropdownSkeleton() {
  return (
    <div className="px-4 py-3 border-b border-gray-100">
      {/* Name skeleton */}
      <Skeleton className="h-4 w-28 mb-2" />
      {/* Email skeleton */}
      <Skeleton className="h-3 w-36 mb-2" />
      {/* Subscription badge skeleton */}
      <Skeleton className="h-5 w-20 rounded-full" />
    </div>
  )
}
